import { Injectable, inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class AccessTokenService {
  private cookies = inject(CookieService);
  private readonly TOKEN_KEY = 'token';

  getToken(): string {
    return this.cookies.get(this.TOKEN_KEY);
  }

  setToken(token: string): void {
    this.cookies.set(this.TOKEN_KEY, token);
  }

  removeToken(): void {
    this.cookies.delete(this.TOKEN_KEY);
  }
}
